import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import fetch from 'isomorphic-fetch';
import {fetchPcBangUserJoinRequest} from '../../../actions/user.actions';
import AddressSearchModal from '../../Common/Address/AddressSeachModal';
import Captcha from '../../Common/Captcha';
import {filterInputKey} from '../../../util/inputValidationUtil';
import {preventDuplicatedSubmit} from '../../../util/duplicatedSubmitPreventUtil';
import {
  Button,
  ButtonGroup,
  PageDescription,
  PageSubTitle,
  StepBox,
  Table,
  PcBangPopup,
} from '../../Common/PageComponents';
import {joinSteps} from '../../../constants/join.constans';
import {EmailValidator} from 'commons-validator-js';

const stateToProps = state => {
  return {
    identification: state.identification,
  };
};

class Form extends Component {
  constructor(props) {
    super(props);

    this.state = {
      noBusinessLicenseNumberPopupOpen: false,
      userNameValidated: false,
      businessLicenseNumberValidated: false,
    };
    this._submitFormWithoutDuplication = preventDuplicatedSubmit(
      captchaToken =>
        this.props.dispatch(
          fetchPcBangUserJoinRequest(this.formData, captchaToken, this.props.history, this.captchaRef)
        ),
      5000
    );
  }

  componentDidMount() {
    if (!this.props.identification.discHash) {
      alert('본인 인증 정보를 불러올 수 없습니다.\n인증 화면으로 이동합니다.');
      this.props.history.push('/member-service/join/identification');
    }
  }

  _prepareMemberJoining(e) {
    e.preventDefault();

    if (!this.state.userNameValidated) {
      alert('ID 중복확인이 되지 않았습니다.');
      return;
    }

    if (!this._validatePassword()) {
      return;
    }

    if (!this.form.noBusinessLicenseNumber.checked && !this.state.businessLicenseNumberValidated) {
      alert('사업자 등록번호 중복확인이 되지 않았습니다.');
      return;
    }

    if (!this._validateAddress()) {
      return;
    }

    if (!this._validateEmailAddress()) {
      alert('잘못 된 이메일 주소 양식입니다. 확인 후 올바른 이메일 주소를 입력해주세요.');
      return;
    }

    this.captchaRef.execute();
  }

  _joinMember(captchaToken) {
    if (captchaToken === undefined || captchaToken === '') {
      window.alert('Captcha token에 문제가 있습니다. 다시 진행해 주세요.');
      return;
    }
    this.formData = new FormData();

    this.formData.append('userName', this.form.username.value);
    this.formData.append('password', this.form.password.value);
    this.formData.append('telephone', `${this.form.tel1.value}-${this.form.tel2.value}-${this.form.tel3.value}`);
    this.formData.append('mobile', `${this.form.mobile1.value}-${this.form.mobile2.value}-${this.form.mobile3.value}`);
    this.formData.append('pcBangName', this.form.pcBangName.value);
    this.formData.append('ownerName', this.props.identification.name);
    this.formData.append('duplicationInformation', this.props.identification.discHash);
    this.formData.append('email', `${this.form.email1.value}@${this.form.email3.value}`);
    if (!this.form.noBusinessLicenseNumber.checked) {
      this.formData.append('businessLicenseNumber', this.form.businessLicenseNumber.value);
      this.formData.append('businessLicenseDocumentFile', this.form.businessLicenseDocumentFile.files[0]);
    }
    this.formData.append(
      'address',
      `(${this.form.zipno.value}) ${this.form.roadNameAddress.value} ${this.form.landLotAddress.value}`
    );
    this.formData.append('agreeForSmsService', this.form.agreeForSmsService.checked);
    this.formData.append('agreeForEmailService', this.form.agreeForEmailService.checked);

    this._submitFormWithoutDuplication(captchaToken);
  }

  _validateAddress() {
    if (
      !this.form.zipno.value.trim() ||
      !this.form.roadNameAddress.value.trim() ||
      !this.form.landLotAddress.value.trim()
    ) {
      alert('주소를 입력해주세요.');
      return false;
    }
    return true;
  }

  _validatePassword() {
    let password = this.form.password.value;
    let passwordConfirm = this.form.passwordConfirm.value;
    if (
      !(
        password.length >= 8 &&
        password.length <= 16 &&
        password.match(/[0-9]+/g) &&
        password.match(/[a-z]+/g) &&
        password.match(/[A-Z]+/g)
      )
    ) {
      alert('비밀번호는 8~16자 사이의 영문 대문자, 소문자, 숫자 혼합하여 생성해야 합니다.');
      return false;
    }

    if (password !== passwordConfirm) {
      alert('비밀번호와 비밀번호 확인란의 값이 서로 일치하지 않습니다.');
      return false;
    }

    return true;
  }

  _preventNonNumericValue(e) {
    if (e.charCode < 48 || e.charCode > 57) {
      e.preventDefault();
    }
  }

  _onEmailDomainChanged(e) {
    e.preventDefault();

    if (this.form.emailDomain.value === '') {
      this.form.email3.value = '';
      this.form.email3.disabled = false;
      this.form.email3.focus();
    } else {
      this.form.email3.value = this.form.emailDomain.value;
      this.form.email3.disabled = true;
    }
  }

  _validateBusinessLicenseNumber(e) {
    e.preventDefault();

    this.setState({
      businessLicenseNumberValidated: false,
    });

    let businessLicenseNumber = this.form.businessLicenseNumber.value.toLowerCase();

    if (!businessLicenseNumber) {
      alert('사업자 등록번호를 입력해주세요.');
      return;
    }

    if (!businessLicenseNumber.match(/^[0-9]{3}-[0-9]{2}-[0-9]{5}$/)) {
      alert('올바른 사업자 등록번호 양식이 아닙니다.');
      return;
    }

    fetch(`${API_URL}/users/by-business-license-number/${encodeURIComponent(businessLicenseNumber)}/exists`)
      .then(response => response.json())
      .then(result => {
        if (result.exists === false) {
          this.setState({
            businessLicenseNumberValidated: true,
          });
          alert('사용 가능한 사업자 등록번호입니다.');
          return;
        }
        alert('이미 사용중인 사업자 등록번호입니다.');
      });
  }

  _validateEmailAddress() {
    return new EmailValidator().isValid(`${this.form.email1.value}@${this.form.email3.value}`);
  }

  _onNoBusinessLicenseNumberChange() {
    let checked = this.form.noBusinessLicenseNumber.checked;
    if (checked) {
      this.setState({
        noBusinessLicenseNumberPopupOpen: true,
      });
      this.form.businessNumber.disabled = true;
      this.form.businessNumber.value = '';
      this.form.attach1.value = '';
      this.form.attach1.disabled = true;
    } else {
      this.form.businessNumber.disabled = false;
      this.form.attach1.disabled = false;
      this.form.businessNumber.focus();
    }
  }

  _onNoBusinessLicenseNumberPopupClosed() {
    this.setState({
      noBusinessLicenseNumberPopupOpen: false,
    });
  }

  _validateUserName(e) {
    e.preventDefault();

    this.setState({
      userNameValidated: false,
    });

    let userName = this.form.username.value.toLowerCase();

    if (!userName) {
      alert('아이디를 입력해주세요.');
      return;
    }

    if (!userName.match(/^[a-z0-9]{4,16}$/) || userName.match(/^[0-9]{4,16}$/) || userName.match(/^[a-z]{4,16}$/)) {
      alert('아이디는 4~16자 사이의 영문, 숫자 혼합하여 생성해야 합니다.');
      return;
    }

    fetch(`${API_URL}/users/by-user-name/${userName}/exists`)
      .then(response => response.json())
      .then(result => {
        if (result.exists === false) {
          this.setState({
            userNameValidated: true,
          });
          alert('사용 가능한 아이디입니다.');
          return;
        }
        alert('이미 사용중인 아이디입니다.');
      });
  }

  _invalidateUserName() {
    this.setState({
      userNameValidated: false,
    });
  }

  render() {
    if (!this.props.identification) {
      return null;
    }

    return (
      <div>
        <StepBox steps={joinSteps} activeIndex={2} />
        <PageDescription>
          현재 운영하고 계신 PC방 및 대표자의 정보를 입력해주세요. <br />
          회원가입 시 본인 명의가 아닌 사업자등록번호를 기재할 경우 발생하는 모든 책임은 당사자에게 있습니다.
        </PageDescription>
        <PageSubTitle title={'기본 등록정보'} />
        <iframe name="iframe_f" height="0" width="0" style={{display: 'none'}}></iframe>
        <form method="post" name="input_f" encType="multipart/form-data" ref={form => (this.form = form)}>
          <input type="hidden" name="discHash" value={this.props.identification.discHash} />
          <input type="hidden" name="ownerName" value={this.props.identification.name} />
          <Table theme="form">
            <colgroup>
              <col width="160" />
              <col width="*" />
            </colgroup>
            <tbody>
              <tr>
                <th>대표자 성명</th>
                <td>
                  {this.props.identification.name}&nbsp;
                  <span className="join_txt_bul1">(본인인증완료)</span>
                </td>
              </tr>
              <tr>
                <th>아이디</th>
                <td>
                  <input
                    type="text"
                    className="input_text"
                    id="c_id"
                    name="username"
                    maxLength="16"
                    onKeyPress={e => filterInputKey(e, [/[0-9]/, /[a-z]/])}
                    style={{width: '172px', imeMode: 'disabled'}}
                    onChange={() => this._invalidateUserName()}
                  />
                  <Button theme={'gray'} size={'small'} onClick={e => this._validateUserName(e)}>
                    ID 중복 확인
                  </Button>
                  <span>아이디는 4~16자 사이의 영문, 숫자 혼합하여 생성해야 합니다.</span>
                </td>
              </tr>
              <tr>
                <th>비밀번호</th>
                <td>
                  <input
                    type="password"
                    className="input_text"
                    style={{width: '172px'}}
                    name="password"
                    id="pw"
                    maxLength="16"
                  />
                  &nbsp;
                  <span>비밀번호는 8-16자 사이의 영문 대문자, 소문자, 숫자 혼합하여 생성해야 합니다.</span>
                </td>
              </tr>
              <tr>
                <th>비밀번호 확인</th>
                <td>
                  <input
                    type="password"
                    className="input_text"
                    style={{width: '172px'}}
                    name="passwordConfirm"
                    id="pw2"
                    maxLength="16"
                  />
                </td>
              </tr>
              <tr>
                <th>PC방 상호명</th>
                <td>
                  <input
                    type="text"
                    className="input_text"
                    style={{width: '172px'}}
                    id="companyname"
                    name="pcBangName"
                    maxLength="50"
                  />
                </td>
              </tr>
              <tr>
                <th>사업자 등록번호</th>
                <td>
                  <input
                    type="text"
                    className="input_text"
                    maxLength="12"
                    id="businessNumber"
                    name="businessLicenseNumber"
                    placeholder="예: 123-45-67890"
                    onKeyPress={e => filterInputKey(e, [/-/, /[0-9]/])}
                    style={{width: '200px'}}
                  />
                  &nbsp;
                  <Button theme={'gray'} size={'small'} onClick={e => this._validateBusinessLicenseNumber(e)}>
                    중복확인
                  </Button>
                  &nbsp;
                  <label>
                    <input
                      type="checkbox"
                      value="n"
                      name="noBusinessLicenseNumber"
                      onChange={() => this._onNoBusinessLicenseNumberChange()}
                    />
                    &nbsp;<span>사업자등록증 미발급</span>
                  </label>
                  <div style={{marginTop: '4px'}}>
                    <input
                      type="file"
                      name="businessLicenseDocumentFile"
                      id="attach1"
                      className="input_text"
                      style={{width: '400px'}}
                    />
                    <div style={{marginTop: '4px'}}>
                      <span>(사업자 등록증 이미지 파일, 2MB 이내)</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>PC방 주소</th>
                <td>
                  <input
                    type="text"
                    className="input_text"
                    style={{width: '92px'}}
                    id="zipno"
                    name="zipno"
                    readOnly="readonly"
                  />
                  &nbsp;
                  <AddressSearchModal
                    triggerButton={
                      <Button theme={'gray'} size={'small'}>
                        주소찾기
                      </Button>
                    }
                    roadNameInputCssSelector="#roadNameAddress"
                    zipCodeInputCssSelector="#zipno"
                  />
                  <div style={{margin: '5px 0'}}>
                    <input
                      type="text"
                      className="input_text"
                      style={{width: '432px'}}
                      id="roadNameAddress"
                      name="roadNameAddress"
                      readOnly="readonly"
                    />
                  </div>
                  <input
                    type="text"
                    className="input_text"
                    style={{width: '432px'}}
                    id="landLotAddress"
                    name="landLotAddress"
                    maxLength="70"
                  />
                </td>
              </tr>
              <tr>
                <th>PC방 전화번호</th>
                <td>
                  <select style={{width: '92px'}} name="tel1" defaultValue="02">
                    <option value="02">02</option>
                    <option value="031">031</option>
                    <option value="032">032</option>
                    <option value="033">033</option>
                    <option value="041">041</option>
                    <option value="042">042</option>
                    <option value="043">043</option>
                    <option value="051">051</option>
                    <option value="052">052</option>
                    <option value="053">053</option>
                    <option value="054">054</option>
                    <option value="055">055</option>
                    <option value="061">061</option>
                    <option value="062">062</option>
                    <option value="063">063</option>
                    <option value="064">064</option>
                    <option value="070">070</option>
                  </select>
                  &nbsp;
                  <input
                    type="text"
                    className="input_text"
                    style={{width: '92px'}}
                    maxLength="4"
                    name="tel2"
                    id="tel2"
                    onKeyPress={e => this._preventNonNumericValue(e)}
                  />
                  &nbsp;
                  <input
                    type="text"
                    className="input_text"
                    style={{width: '92px'}}
                    maxLength="4"
                    name="tel3"
                    id="tel3"
                    onKeyPress={e => this._preventNonNumericValue(e)}
                  />
                </td>
              </tr>
              <tr>
                <th>휴대폰번호</th>
                <td>
                  <select style={{width: '92px'}} name="mobile1" defaultValue="010">
                    <option value="010">010</option>
                    <option value="011">011</option>
                    <option value="016">016</option>
                    <option value="017">017</option>
                    <option value="018">018</option>
                    <option value="019">019</option>
                  </select>
                  &nbsp;
                  <input
                    type="text"
                    className="input_text"
                    style={{width: '92px'}}
                    maxLength="4"
                    name="mobile2"
                    id="htel2"
                    onKeyPress={e => this._preventNonNumericValue(e)}
                  />
                  &nbsp;
                  <input
                    type="text"
                    className="input_text"
                    style={{width: '92px'}}
                    maxLength="4"
                    name="mobile3"
                    id="htel3"
                    onKeyPress={e => this._preventNonNumericValue(e)}
                  />
                  &nbsp;
                  <label>
                    <input type="checkbox" name="agreeForSmsService" value="y" />
                    &nbsp;<span>SMS 수신 허용</span>
                  </label>
                </td>
              </tr>
              <tr>
                <th>이메일</th>
                <td>
                  <input
                    type="text"
                    className="input_text"
                    style={{width: '142px', marginRight: '5px'}}
                    name="email1"
                    maxLength="25"
                    id="email1"
                  />
                  @
                  <input
                    type="text"
                    className="input_text"
                    style={{width: '142px', marginLeft: '5px'}}
                    maxLength="25"
                    id="email3"
                    name="email3"
                  />
                  &nbsp;
                  <select
                    style={{width: '122px'}}
                    name="emailDomain"
                    onChange={e => this._onEmailDomainChanged(e)}
                    defaultValue=""
                  >
                    <option value="">직접입력</option>
                    <option value="naver.com">naver.com</option>
                    <option value="gmail.com">gmail.com</option>
                    <option value="hanmail.net">hanmail.net</option>
                    <option value="nate.com">nate.com</option>
                  </select>
                  &nbsp;
                  <label>
                    <input type="checkbox" name="agreeForEmailService" value="y" />
                    &nbsp;<span>e-mail 수신 허용</span>
                  </label>
                  <input type="hidden" name="${_csrf.parameterName}" value="${_csrf.token}" />
                  <div style={{marginTop: '4px'}}>
                    <span>차후 ID/PW 찾기를 위해 이용되오니 꼭 유효한 이메일 주소를 기입해주시기 바랍니다.</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </Table>
        </form>
        <ButtonGroup>
          <Captcha
            ref={captchaRef => (this.captchaRef = captchaRef)}
            onVerify={captchaToken => this._joinMember(captchaToken)}
          />
          <Button onClick={e => this._prepareMemberJoining(e)}>확인</Button>
        </ButtonGroup>
        <PcBangPopup
          open={this.state.noBusinessLicenseNumberPopupOpen}
          onClose={() => this._onNoBusinessLicenseNumberPopupClosed()}
          title={'공지사항'}
        >
          <div className="notice">알려드립니다.</div>
          <strong>가입 후 20일 이내</strong> 고객 센터로 사업자등록증 사본을 접수 하지 않으실 경우 서비스 이용에 제한이
          있을 수 있습니다. 원활한 PC방 서비스를 이용하기 위해서 기한 내에 사업자등록증 사본을 접수하시어 불이익을 받지
          않으시길 바랍니다.
          <div style={{marginTop: '20px'}}>사업자등록증 접수 방법 : 팩스 또는 1:1문의</div>
          <ul style={{marginTop: '20px'}}>
            <li>고객센터 : 1688-1011</li>
            <li>팩스번호 : 02-863-4850</li>
          </ul>
          <ButtonGroup>
            <Button theme={'gray'} onClick={() => this._onNoBusinessLicenseNumberPopupClosed()}>
              확인
            </Button>
          </ButtonGroup>
        </PcBangPopup>
      </div>
    );
  }
}

export default withRouter(connect(stateToProps)(Form));
